import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AlertService, UserService, LoaderService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { PrinterSetupService } from 'sce-home';
import { ReportParam } from './report-param-model';
import { DetailViewKeyEventHandlerService } from '../../services/detail-view-key-event-handler.service';
import { ViewReportDataEditorService } from '../../../features/control/inventory/view-report/services/viewreport-data-editor.service';
import { ModalService } from '../../services/modal.service';
import { DatePickerConfigService } from '../../components/datepicker/datepicker-config.service';
import { DetailedEntityDataService } from '../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { SearchService } from '../../search/search.service';
import { PrinterService } from '../../services/printer.service';
import { FileUtilityService } from '../../services/file-utility.service';

@Component({
  selector: 'lfwms-print-lookup',
  templateUrl: './print-lookup.component.html',
  styleUrls: ['./print-lookup.component.css']
})
export class PrintLookupComponent implements OnInit {

  public reportDefaultValues: any;
  public fieldsToPrintReport = {};
  public printerIds: any;
  public title: string = '';
  public userInputFields: any;
  public showPage = false;
  public printerparameter = [];
  public reportTypes = [];
  public enableSubmitButton = false;
  // [LFWM-3396] Added print preview flag to disable the button in Shipref search screen
  public enablePreviewButton = false;
  public typeSelected: any;
  public selectedPaperPrinter: any;
  public isPresentList = [];
  public norPresentList = [];
  public reportInputParams = [];
  public existingValues = [];
  public primaryDataMap: any;
  public defaultPrinters: any;
  public printEventSubject = new Subject<any>();
  public printReqData = {
    printerID: '',
    isPaperPrinter: 'Y',
    noOfCopy: 1
  };
  public maxParameter: number = 5;
  private showKeyValueParams: boolean = false;
  public reportConfig: any;
  public dataEditor: ViewReportDataEditorService;
  public paramList: Array<ReportParam> = []; // contains both KeyField and Extended Prameter details
  public reportSource: string = 'DocReport';
  public keyFieldList: Array<ReportParam> = [];
  public facilityMetaData: any; // to set the facility option values
  public keyEventHandler: DetailViewKeyEventHandlerService;
  public offset: number = 0;
  public dateFormat: string;
  public dateTimeFormat: string;
  public parentDataService: DetailedEntityDataService;
  public minLineNumber: string = ''; // [LFWM-1980] - first detail line item number of records in server side
  public maxLineNumber: string = ''; // [LFWM-1980] - last detail line item number of records in server side
  /* [LFWM-1981] -  false - if print functionality from ASN, Trade Returns, Inbound XDock and Outbound XDock Screens, Wave Control, Inventory QC,
   * [if selected rows count from detail > 0] */
  public printFromHeader: boolean = true;
  /* [LFWM-1980] - used to store the key of selectedReportConfig [if key = detail tablle idProperty]
  Ex: [for ASN screen - receiptLineNumber, for Transfer Screen - transferLineNum */
  public lineNumberConfigArray = [];
  // [LFWM-1981] -  if selected line items count > 0, then storer the existingValues is an Array to send the backend.
  public existingValuesArray = [];
  /* [LFWM- 1981, 2027] - detail table id list in which the detail level print is enabled.. */
  public tableIdsDetailLevelPrintEnabled = [
    'asndetailtd',
    'trdetailtd',
    'xdockdetailtd',
    'wavecntrlwaveodrtd',
    'wavecntrlldodrtd',
    'wavecntrlmbolodrtd',
    'invqcdetailtd',
    'shiprefdetailtd',
    'transferdetailtd',
    /* 'podetailtd',
    'adjdetailtd',
    'uccadjdtltd',
    'kitdetailtd',
    'wodetailtd',
    'sodetailtd' */
  ];
  public tableSearchServiceForWaveControl: SearchService;
  public selectedRows: any = [];
  public tableId: string;
  public showParamSection: boolean = false; // true - after selecting report type
  public printerService: PrinterService;
  public printerGroups: any;
  public selectedPrinterGroup: any;
  public selectedPrinterGroupVal: any;
  public completedJobs: any = [];
  public reportCounts: string;
  public showPrintPreviewSection: boolean;
  public completedJobIds: any = [];

  constructor(public modalService: ModalService,
    public resourceService: ResourceService,
    private printerSetupService: PrinterSetupService,
    private alertService: AlertService,
    private dateConfigService: DatePickerConfigService,
    private userService: UserService,
    private fileUtilityService: FileUtilityService,
    private loaderService: LoaderService
  ) {
    this.printEventSubject = new Subject<any>();
  }

  ngOnInit() {
    this.dateFormat = this.dateConfigService.defaultDateDisplayFormat;
    this.dateTimeFormat = this.dateConfigService.defaultDateDisplayFormat + ' ' + this.dateConfigService.defaultTimeDisplayFormat;
    // LFWM-2250 - fetch printer groups
    this.fetchPrinterGroup();
  }

  /* reportConfig - report details with parameters
    * inputValues - contain documentType,  storerKey, facility from parent screen [documentTpe - primaryTableId]
    * printerIds - default labelPrinter and paperPrinter of the logged in user. already set in set default printer screen
    * showKeyValueParams - true - if reportSource is ViewReport
    * dataService - dataService instance from parent screen
    * tableSearchService - for wave control screen - because wave control has more than one detail search service and detail table */
  public setInitialData(reportConfig: any, inputValues: any, printerIds: any, primaryDataMap: any,
    showKeyValueParams: any, reportSource: any, dataService: DetailedEntityDataService,
    tableSearchService: any, printerService: any) {
    this.reportConfig = reportConfig;
    this.userInputFields = reportConfig;
    this.reportDefaultValues = inputValues;
    this.printerIds = printerIds;
    this.reportTypes = reportConfig.reportList;
    this.primaryDataMap = primaryDataMap;
    this.printReqData.printerID = this.printerIds['paperPrinter'];
    this.selectedPrinterGroup = this.printerIds['scePrinterGroup'];
    // LFWM-2250 - setting All for empty value
    this.selectedPrinterGroupVal = this.selectedPrinterGroup;
    if (this.selectedPrinterGroupVal === '') {
      this.selectedPrinterGroupVal = ' ';
      this.selectedPrinterGroup = 'ALL';
    }
    this.showPage = false;
    this.showKeyValueParams = showKeyValueParams;
    this.reportSource = reportSource;
    this.parentDataService = dataService;
    this.tableSearchServiceForWaveControl = tableSearchService;
    this.printerService = printerService;

    if (this.reportTypes && this.reportTypes.length === 1) {
      this.typeSelected = this.reportTypes[0].cVal;
      this.reportTypeChanged();
    }
  }

  public setDataTableEditor(tableEditor: any, keyEventHandler: any) {
    if (tableEditor) {
      this.dataEditor = tableEditor;
      this.keyEventHandler = keyEventHandler;
    }
  }

  public paperPrinterChanged() {
    if (this.printReqData.isPaperPrinter === 'Y') {
      this.printReqData.printerID = this.printerIds['paperPrinter'];
    } else {
      this.printReqData.printerID = this.printerIds['labelPrinter'];
    }
    // [LFWM-2223][UAT - TW | Set Default Printer does NOT work][changes reflect when paper printer is changed]
    this.selectedPaperPrinter = this.printReqData.printerID;
    if(this.selectedPaperPrinter && this.typeSelected){
      this.enablePreviewButton = true;
      this.enableSubmitButton = true;
    }
  }

  public reportTypeChanged() {
    if (this.typeSelected ) {
      if(this.selectedPaperPrinter){
        this.enableSubmitButton = true;
        this.enablePreviewButton = true;
      }
      else{
      this.enableSubmitButton = false;
      this.enablePreviewButton = false;
      }

      const selectedReportConfig = this.getSelectedReportConfig();
      if (selectedReportConfig) {
        this.showParamsForSelectedReport(selectedReportConfig);
      }
      this.showPage = true;

      // [LFWM-3396] Disabling print Preview button for Ship Ref Print from search screen
      if (this.parentDataService && this.parentDataService.pageType === "search") {        
        this.tableId = this.parentDataService.primarySearchParams.tableId;
        this.printFromHeader = this.parentDataService.primarySearchService.getSelectedRows().length === 0 ? true : false;
        if (!this.printFromHeader) {
          this.selectedRows = this.parentDataService.primarySearchService.getSelectedRows();
        }
        this.enablePreviewButton = false;
      }

      /* [LFWM-1981] - As of now print from detail is implemented for ASN, Trade Returns, Inbound XDock and Outbound XDock, Inventory QC */
      else if (this.parentDataService && this.parentDataService.primarySearchParams &&
        this.tableIdsDetailLevelPrintEnabled.indexOf(this.parentDataService.detailsSearchParams.tableId) !== -1) {
        this.tableId = this.parentDataService.detailsSearchParams.tableId;
        this.printFromHeader = this.parentDataService.detailsSearchService.getSelectedRows().length === 0 ? true : false;
        if (!this.printFromHeader) {
          this.selectedRows = this.parentDataService.detailsSearchService.getSelectedRows();
        }
      }

      /* [LFWM-2027] - print from detail is enabled for Wave Control Screen all three tabs -[wave, load, shipRef] */
      if (this.tableSearchServiceForWaveControl && this.tableSearchServiceForWaveControl.searchParams &&
        this.tableIdsDetailLevelPrintEnabled.indexOf(this.tableSearchServiceForWaveControl.searchParams.tableId) !== -1) {
        this.tableId = this.tableSearchServiceForWaveControl.searchParams.tableId;

        //LFWM-4078- corrected selected rows for tabs -[load, shipRef]
        this.selectedRows = [];
        if(this.tableId === 'wavecntrlldodrtd'){
          let cValConcat="";
          for(let key in this.parentDataService['LoadkeyMap']){
            const cellInfo: any = new Object();
            const rowObject: any = new Object();
            rowObject.cells = {};
            if(this.parentDataService['LoadkeyMap'][key].cVal){
              cellInfo.cVal = this.parentDataService['LoadkeyMap'][key].loadkey;
              if(this.showParamSection)
                rowObject.cells['Loadkey'] = cellInfo;
              else
                rowObject.cells['loadKey'] = cellInfo;
              if(!cValConcat)
                cValConcat =  cellInfo.cVal;
              else
                cValConcat =  cValConcat+','+cellInfo.cVal;
            }
            if(rowObject.cells.loadKey || rowObject.cells.Loadkey)
              this.selectedRows.push(rowObject);
          }
          if(this.paramList.length > 0) {
            for (let i = 0; i < this.paramList.length; i++) {
              if (this.paramList[i].label.toLowerCase() == "loadkey" && this.paramList[i].type == "keyfieldparamwithlabel") {
                this.paramList[i].cVal = cValConcat;
              }
            }
          }
          this.printFromHeader = this.selectedRows.length === 0 ? true : false;
        }else if(this.tableId == 'wavecntrlmbolodrtd'){
          let cValConcat="";
          for(let key in this.parentDataService['MBOLkeyMap']){
            const cellInfo: any = new Object();
            const rowObject: any = new Object();
            rowObject.cells = {};
            if(this.parentDataService['MBOLkeyMap'][key].cVal){
              cellInfo.cVal = this.parentDataService['MBOLkeyMap'][key].MBOLkey;
              if (this.showParamSection)
                rowObject.cells['MBOLKEY'] = cellInfo;
              else
                rowObject.cells["mbolKey"] = cellInfo;

              if (!cValConcat)
                cValConcat = cellInfo.cVal;
              else
                cValConcat = cValConcat + ',' + cellInfo.cVal;
            }
            if(rowObject.cells.MBOLKEY || rowObject.cells.mbolKey)
              this.selectedRows.push(rowObject);
          }
          if(this.paramList.length > 0) {
            for (let i = 0; i < this.paramList.length; i++) {
              if (this.paramList[i].label.toLowerCase() == "MBOLKEY".toLowerCase() && this.paramList[i].type == "keyfieldparamwithlabel") {
                this.paramList[i].cVal = cValConcat;
              }
            }
          }
          this.printFromHeader = this.selectedRows.length === 0 ? true : false;
        }else{
          this.printFromHeader = this.tableSearchServiceForWaveControl.getSelectedRows().length === 0 ? true : false;
          if (!this.printFromHeader) {
            this.selectedRows = this.tableSearchServiceForWaveControl.getSelectedRows();
          }
        }
      }

      /* [LFWM-1980] - if the user doesn't select any line items then the print is consider as print from header level
      otherwise it is print from detail level */
      if (this.printFromHeader && this.parentDataService && this.parentDataService.primarySearchParams &&
        this.tableIdsDetailLevelPrintEnabled.indexOf(this.parentDataService.detailsSearchParams.tableId) !== -1) {
        for (const key of Object.keys(selectedReportConfig.keyFieldNameWithoutLabel)) {
          if (selectedReportConfig.keyFieldNameWithoutLabel[key] === this.parentDataService.detailsSearchParams.idProperty) {
            this.lineNumberConfigArray.push(key);
          }
        }
        /* [LFWM-1980] - for ASN, Trade Returns, Inbound XDock, Outbound XDock - printFromHeader - true - if detail tablle idProperty
           exist in selectedReportConfig  Ex: [for ASN screen - receiptLineNumber, for Transfer Screen - transferLineNum] and
           selectedRows count zero,
           then need to fetch first and last detail line number of records available in server side.
           no.of line item count - 0 - first and last line number is passed as null.
           no.of line item count - 1 - first line number is assigned for both first and last line number */
        if (this.lineNumberConfigArray.length > 0) {
          this.printerService.getMinMaxOfLineItems(this.parentDataService.detailsSearchParams.tableId,
            this.parentDataService.getPrimaryDataIdValue()).subscribe(resp => {
              if (resp) {
                this.minLineNumber = resp['minLineNumber'] !== '0' ? resp['minLineNumber'] : '';
                this.maxLineNumber = resp['maxLineNumber'] !== '0' ? resp['maxLineNumber'] : '';
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
        }
      }
    } else {
      this.enableSubmitButton = false;
      this.enablePreviewButton = false;
      this.showPage = false;
    }
  }

  private getSelectedReportConfig() {
    let selectedReportConfig = null;
    if (this.reportSource === 'DocReport') {
      this.userInputFields.reportDetailMapList.forEach((report: any) => {
        if (report[this.typeSelected]) {
          selectedReportConfig = report[this.typeSelected];
        }
      });
    } else if (this.reportSource === 'ViewReport') {
      const userReportCheck = this.userInputFields && this.userInputFields.reportDetailMapList && 
                              this.userInputFields.reportDetailMapList.reportId === this.typeSelected;
      if ( userReportCheck ) {
        if (this.userInputFields.reportDetailMapList.reportParamMap) {
          selectedReportConfig = this.userInputFields.reportDetailMapList.reportParamMap;
        }
      }
    }
    return selectedReportConfig;
  }

  public submitPrintJob(reportInput: any, printerInput: any) {
    if (!this.validateMandatoryFields(printerInput)) {
      return;
    }
    this.format(reportInput);
    const fieldsToPrintReportArray = [];
    if (this.reportSource === 'DocReport') {
      /* [LFWM-1981] - Enabling print from detail level [if selected row count > 0] for all the screens
      which having print functionality.
       [LFWM-2027] - Enabling print from detail level for - Wave Control screen
       for all the three tabs [wave, load, shipRef] */
      if (!this.printFromHeader && this.tableIdsDetailLevelPrintEnabled.indexOf(this.tableId) !== -1) {
        for (let index = 0; index < this.selectedRows.length; index++) {
          this.fieldsToPrintReport = {
            documentType: this.reportDefaultValues.documentType,
            reportID: this.typeSelected,
            storerkey: this.reportDefaultValues.storer,
            facility: this.reportDefaultValues.facility,
            computerName: '',
            printerID: this.selectedPaperPrinter,
            noOfCopy: printerInput.noOfCopy,
            isPaperPrinter: printerInput.isPaperPrinter,
            printParams: this.getPrintParams(reportInput, this.existingValuesArray[index])
          };
          fieldsToPrintReportArray.push(this.fieldsToPrintReport);
        }
        this.printReportNotifyEvent(fieldsToPrintReportArray);
      } else {
        /* [LFWM-1980] - Applicable for all the screens which having print functionality. */
        this.fieldsToPrintReport = {
          documentType: this.reportDefaultValues.documentType,
          reportID: this.typeSelected,
          storerkey: this.reportDefaultValues.storer,
          facility: this.reportDefaultValues.facility,
          computerName: '',
          printerID: this.selectedPaperPrinter,
          noOfCopy: printerInput.noOfCopy,
          isPaperPrinter: printerInput.isPaperPrinter,
          printParams: this.getPrintParams(reportInput, this.existingValues)
        };
        fieldsToPrintReportArray.push(this.fieldsToPrintReport);
        // LFWM- 2833 duplicate print request
        this.printReportNotifyEvent(fieldsToPrintReportArray);
      }
    } else if (this.reportSource === 'ViewReport') {
      this.fieldsToPrintReport = {
        moduleId: 'ViewReport',
        reportId: this.typeSelected,
        printerID: this.selectedPaperPrinter,
        noOfCopy: printerInput.noOfCopy,
        isPaperPrinter: printerInput.isPaperPrinter,
        printParams: this.getPrintParams(reportInput, this.existingValues)
      };
      // LFWMS -2023 for viewReport screen,no need to push fields of viewReport into array
      this.printReportNotifyEvent(this.fieldsToPrintReport);
    }
  }

  // method to format the existingparam
  public getPrintParams(reportInput: any, existingparam: any) {
    const printparams = [];
    existingparam.forEach((param: any) => {
      printparams.push({
        'keyField': param.key,
        'displayLabel': param.Value,
        'value': param.uservalue
      });
    });
    return printparams;
  }

  private printReportNotifyEvent(value: any) {
    this.printEventSubject.next(value);
  }

  public printReportReceiveEvent(): Observable<any> {
    return this.printEventSubject.asObservable();
  }


  // method to modify the parameters of selected report in a required format
  public showParamsForSelectedReport(selectedReportConfig: any) {
    this.paramList = [];

    // LFWM - 2354-View reports to default storerkey and facility based on user restrictions
    // populated the user restricted storer and facility value if exist
    // instead  of the default storer and facility value from backend
    let facilityExist = false;
    let storerExist = false;
    const userFacilities = this.userService.getUserRestrictions('Facility');
    const userStorer = this.userService.getUserRestrictions('Storer');
    if (this.showKeyValueParams) {
      Object.keys(selectedReportConfig).forEach(param => {
        if (this.isFacilityField(selectedReportConfig[param].ParmLabel)) {
          if (userFacilities.length > 0) {
            selectedReportConfig[param].DefaultVal = userFacilities[0];
          }
          facilityExist = true;
        }
        if (this.isStorerField(selectedReportConfig[param].ParmLabel)) {
          if (userStorer.length > 0) {
            selectedReportConfig[param].DefaultVal = userStorer[0];
          }
          storerExist = true;
        }
      });
      if (!facilityExist && userFacilities.length > 0) {
        selectedReportConfig['FacilityParm'] = {
          DataType: 'String',
          DefaultVal: userFacilities[0],
          ParmLabel: 'Facility'
        };
      }
      if (!storerExist && userStorer.length > 0) {
        selectedReportConfig['StorerParm'] = {
          DataType: 'String',
          DefaultVal: userStorer[0],
          ParmLabel: 'Storer'
        };
      }


      this.showParamSection = true;
      // for report config - ViewReport - print from View Report screen
      Object.keys(selectedReportConfig).forEach(param => {
        this.paramList.push(
          {
            'key': param, 'label': selectedReportConfig[param].ParmLabel, 'cVal': selectedReportConfig[param].DefaultVal,
            'disable': false, 'dataType': selectedReportConfig[param].DataType
          }
        );
        if (this.isFacilityField(selectedReportConfig[param].ParmLabel)) {
          if (!this.facilityMetaData) {
            this.facilityMetaData = [];
            this.printerSetupService.getFacilityValues().subscribe((resp: any) => {
              if (resp) {
                this.facilityMetaData = resp;
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
          }
        }
      });
    } else { // for report config - DocReport - print from all the screens except View Report
      // array of key field parameters with label and value which should be displayed
      const keyFieldParmListWithLabelAndValue = selectedReportConfig.keyFieldParmLabelAndValue;
      // array of key field parameters without label and need not to display but need to append this in request along with input params
      const keyFieldParmListWithoutLabel = selectedReportConfig.keyFieldNameWithoutLabel;
      // array of key extended parameters and default value with label and value which should be displayed
      const extendedParamDefaultList = selectedReportConfig.extendedParmAndDefaultValue;
      // array of key extended param with label and value which should be displayed
      const extendedParamList = selectedReportConfig.extendedParm;
      for (let i = 0; i < keyFieldParmListWithLabelAndValue.length; i++) {
        // type - added for - to identify the value should be taken from the parent screen or from the config
        // if the parmValue is available in the parent screen [EX: ASN - receiptKey] then the value of that field should be assigned in cVal.
        if (this.primaryDataMap[keyFieldParmListWithLabelAndValue[i].parmValue]) {
          this.paramList.push(
            {
              'key': keyFieldParmListWithLabelAndValue[i].parmKey, 'label': keyFieldParmListWithLabelAndValue[i].parmLabel,
              'cVal': this.primaryDataMap[keyFieldParmListWithLabelAndValue[i].parmValue].cVal, 'disable': true,
              'dataType': 'String', 'show': true, 'type': 'keyfieldparamwithlabel'
            });
        } else {
          /* if the parmValue is not available in the parent screen then the default value is assigned in cVal.
          this field is editable user can change the value */
          this.paramList.push(
            {
              'key': keyFieldParmListWithLabelAndValue[i].parmKey, 'label': keyFieldParmListWithLabelAndValue[i].parmLabel,
              'cVal': keyFieldParmListWithLabelAndValue[i].parmValue, 'disable': false,
              'dataType': 'String', 'show': true, 'type': 'keyfieldparamwithlabel'
            });
        }
      }
      // keyFieldParmListWithoutLabel - need not to display but need to append in request
      for (const key of Object.keys(keyFieldParmListWithoutLabel)) {
        this.paramList.push(
          {
            'key': key, 'label': '', 'cVal': keyFieldParmListWithoutLabel[key],
            'dataType': 'String', 'show': false, 'type': 'keyfieldparamwithoutlabel'
          });
      }
      // extended param is displayed with default value from config. and user can edit the field
      if (selectedReportConfig.needExtendedParm === 'Y') {
        this.getExtendedParamList(extendedParamList,false,true);
        for (let i = 0; i < extendedParamDefaultList.length; i++) {
          this.paramList.push(
            {
              'key': extendedParamDefaultList[i].parmKey, 'label': extendedParamDefaultList[i].parmLabel, 'cVal': extendedParamDefaultList[i].parmValue,
              'disable': false, 'show': true, 'dataType': 'String', 'type': 'extendedParam'
            });
        }
      } else {
        // needExtendedParm - N - no need to disply but need to send the values in request
        this.getExtendedParamList(extendedParamList,true,false);
        for (let i = 0; i < extendedParamDefaultList.length; i++) {
          this.paramList.push(
            {
              'key': extendedParamDefaultList[i].parmKey, 'label': extendedParamDefaultList[i].parmLabel, 'cVal': extendedParamDefaultList[i].parmValue,
              'show': false, 'dataType': 'String', 'type': 'extendedParam'
            });
        }
      }
      // parameters section should be shown if no.of displayed parameter is more than 0.
      const paramListToDisplay = this.paramList.filter(param => param.show === true);
      if (paramListToDisplay.length > 0) {
        this.showParamSection = true;
      } else {
        this.showParamSection = false;
      }
    }
  }
  //[LFWM-3152]
  public getExtendedParamList(extendedParamList,disable: boolean,show: boolean){
    for (let i = 0; i < extendedParamList.length; i++) {      
      this.paramList.push(
        {
          'key': extendedParamList[i].extendedParmNo, 'label': extendedParamList[i].extendedParmValue, 'cVal': '',
          'disable': disable,'show': show, 'dataType': 'String', 'type': 'extendedParam'
        });
    }
  }

  // 2250- added change for fetching default printers by printer group
  private fetchDefaultPrinters() {
    this.printerSetupService.fetchDefaultPrintersbyPrinterGroup(this.selectedPrinterGroupVal)
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            this.defaultPrinters = resp['printerDetails'];
            /**
             * if default printer is available in response it should be auto populated
             */
            if (resp['defaultPrinterDetails'] && resp['defaultPrinterDetails']['printerId']) {
              this.selectedPaperPrinter = resp['defaultPrinterDetails']['printerId'];
              if(this.selectedPaperPrinter && this.typeSelected){
                this.enablePreviewButton = true;
                this.enableSubmitButton = true;
              }
            }
            // [LFWM-2223][UAT - TW | Set Default Printer does NOT work][set default parameter if available]
            if (this.selectedPaperPrinter === null || this.selectedPaperPrinter === undefined || this.selectedPaperPrinter === '') {
              this.selectedPaperPrinter = this.userService.userInfo.defaultPrinter.paperPrinter;
              if(this.selectedPaperPrinter && this.typeSelected){
                this.enablePreviewButton = true;
                this.enableSubmitButton = true;
              }
            }
            if(this.selectedPaperPrinter == null){
              this.enablePreviewButton=false;
              this.enableSubmitButton=false;
            }
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.error));
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
  }
  // LFWM-2250 - added change for fetching default printers by printer group
  private fetchPrinterGroup() {
    this.printerSetupService.fetchPrinterGroup()
      .subscribe((resp: any) => {
        this.printerGroups = resp;
        const wildcardClausePresent: boolean
          = this.printerGroups
            .filter((keyValueObject: any) => {
              return keyValueObject === 'ALL';
            }).length > 0;
        if (!wildcardClausePresent && this.printerGroups[0] === '') {
          this.printerGroups[0] = 'ALL';
        }
        this.fetchDefaultPrinters();
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
  }
  public onChange() {
    if(this.selectedPaperPrinter != "Pick a PrinterId..." && this.typeSelected){
      this.enableSubmitButton = true;
      this.enablePreviewButton = true;
    } 
    else{
      this.enableSubmitButton = false;
      this.enablePreviewButton = false; 
    }   
    this.alertService.clearAll();
  }
  // 2250 - on select of printer group, fetch printers based on printer group
  public onChangePrinterGroup() {
    if (this.selectedPrinterGroup === 'ALL') {
      this.selectedPrinterGroupVal = ' ';
    } else {
      this.selectedPrinterGroupVal = this.selectedPrinterGroup;
    }
    this.fetchDefaultPrinters();
    this.alertService.clearAll();
  }
  public onValueChangeInTypeaheadTextBox(event: any, field: any) {
    field.cVal = event.target.value;
  }

  public isStorerField(label: any) {
    let storerFlag: boolean;
    storerFlag = label.includes('storer') || label.includes('Storer');
    return storerFlag;
  }
  public isFacilityField(label: any) {
    let facFlag: boolean;
    facFlag = label.includes('facility') || label.includes('Facility');
    return facFlag;
  }

  public validateMandatoryFields(printerInput: any) {
    if (!printerInput.noOfCopy) {
      this.alertService.clearAll().error(this.resourceService.get('msg_copy_mand'));
      return false;
    } else if (printerInput.noOfCopy < 1) {
      this.alertService.clearAll().error(this.resourceService.get('msg_val_print_NoOfCopy_greater'));
      return false;
    } else if (!this.selectedPaperPrinter) {
      this.alertService.clearAll().error(this.resourceService.get('msg_prnt_mand'));
      return false;
    }
    return true;
  }

  // [LFWM-2765] - formatting the values as per the request format
  public format(reportInput: any) {
    this.existingValues = [];
    if (this.reportSource === 'ViewReport') {
      reportInput.forEach((param: any) => {
        this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': param.cVal });
      });
    }
    // Adding this logic so as to bind the keyfield params which are not used in display but need to send
    // along the report input params to the backend service
    if (this.reportSource === 'DocReport') {
      if (this.paramList && this.paramList.length > 0) {
        /* [LFWM-1980] - Print Report - [if selected row count is 0] - All the screens
        which having print functionality */
        if (this.tableIdsDetailLevelPrintEnabled.indexOf(this.tableId) !== -1) {
          if (this.printFromHeader) {
            this.paramList.forEach((param: any) => {
              // type - keyfieldparamwithoutlabel - value is taken from parent screen EX: ASN
              if (param.type === 'keyfieldparamwithoutlabel') {
                // check for - if param.cVal is available in accordions - [EX: Screen -ASN, param.cVal -receiptKey]
                if (this.primaryDataMap[param.cVal]) {
                  this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': this.primaryDataMap[param.cVal].cVal });
                  /* [LFWM-1980] - if line number param is exist in report config, than first occurance should be replaced with first line number,
                  and second occurance should be replaced with last line number*/
                } else if (this.lineNumberConfigArray[0] === param.key) {
                  this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': this.minLineNumber });
                } else if (this.lineNumberConfigArray[1] === param.key) {
                  this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': this.maxLineNumber });
                } else {
                  this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': '' });
                }
              } else {
                // type - extendedParam or keyfieldparamwithlabel.
                this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': param.cVal });
              }
            });
          } else {
            /* [LFWM-1981] - Print Report [From detail level - if selected row count > 0] - for all the
            screens which having print functionality.
            [LFWM-2027] - Enabling print from detail level for - Wave Control screen
            for all the three tabs [wave, load, shipRef] */
            this.existingValuesArray = [];
            this.selectedRows.forEach((row: any) => {
              this.existingValues = [];
              this.paramList.forEach((param: any) => {
                // type - keyfieldparamwithoutlabel - value is taken from parent screen
                if (param.type === 'keyfieldparamwithoutlabel') {
                  // check for - if param.cVal is available in primaryDataMap [accordions] - [EX: Screen -ASN, param.cVal -receiptKey]
                  if (row.cells[param.cVal]) {
                    /* check for - if param.cVal is available in selected row or table - [EX: Screen - ASN, param.cVal - receiptLineNumber,
                    Screen - Transfer, param.cVal - transferLineNum] */
                      this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': row.cells[param.cVal].cVal });
                  }else if (this.primaryDataMap[param.cVal]) {
                    this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': this.primaryDataMap[param.cVal].cVal });
                  } else {
                    this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': '' });
                  }
                } else {
                  // type - extendedParam or keyfieldparamwithlabel.
                  //LFWM-4078- taking all the selected wave item[load,ship Ref] values from the selectedRows array
                  if((this.tableId === 'wavecntrlmbolodrtd' || this.tableId === 'wavecntrlldodrtd')){
                    //if(this.tableId === 'wavecntrlmbolodrtd'){
                      if(row.cells[param.label] && row.cells[param.label].cVal)
                        this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': row.cells[param.label].cVal });
                      else
                        this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue':param.cVal});
                    // }
                    // else if(this.tableId === 'wavecntrlldodrtd'){
                      //this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': row.cells['loadkey'].cVal });
                    //}
                  }
                  else{
                    this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': param.cVal });
                  }
                }
              });
              this.existingValuesArray.push(this.existingValues);
            });
          }
        } else { // Applicable for screens other than above mentioned screens
          this.paramList.forEach((param: any) => {
            if (param.type === 'keyfieldparamwithoutlabel') {
              if (this.primaryDataMap[param.cVal]) {
                this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': this.primaryDataMap[param.cVal].cVal });
              } else {
                this.existingValues.push({ 'key': param.key, 'Value': param.cVal, 'uservalue': '' });
              }
            } else {
              // type - extendedParam or keyfieldparamwithlabel.
              this.existingValues.push({ 'key': param.key, 'Value': param.label, 'uservalue': param.cVal });
            }
          });
        }
      }
    }
  }

  // [LFWM-2765] - called on click of preview button
  public printPreview(reportInput: any, printerInput: any) {
    this.completedJobs = [];
    this.completedJobIds = [];
    this.showPrintPreviewSection = true;
    // lbl_preview_item_count - Preview (%) items
    this.reportCounts = this.resourceService.get('lbl_preview_item_count').replace('%', 0);
    const jobIds = '';
    // const jobIds = '1053|1054|1055'; // sample test data
    const startTime = '';
    if (!this.validateMandatoryFields(printerInput)) {
      return;
    }
    this.format(reportInput);
    let request: any;
    if (this.reportSource === 'DocReport') {
      let printReq = [];
      if (!this.printFromHeader && this.tableIdsDetailLevelPrintEnabled.indexOf(this.tableId) !== -1) {
        for (let index = 0; index < this.selectedRows.length; index++) {
          this.fieldsToPrintReport = {
            documentType: this.reportDefaultValues.documentType,
            reportID: this.typeSelected,
            storerkey: this.reportDefaultValues.storer,
            facility: this.reportDefaultValues.facility,
            computerName: '',
            printerID: this.selectedPaperPrinter,
            noOfCopy: printerInput.noOfCopy,
            isPaperPrinter: printerInput.isPaperPrinter,
            printParams: this.getPrintParams(reportInput, this.existingValuesArray[index])
          };
          printReq.push(this.fieldsToPrintReport);
        }
      } else {
        printReq.push({
          documentType: this.reportDefaultValues.documentType,
          reportID: this.typeSelected,
          storerkey: this.reportDefaultValues.storer,
          facility: this.reportDefaultValues.facility,
          computerName: '',
          printerID: this.selectedPaperPrinter,
          noOfCopy: printerInput.noOfCopy,
          isPaperPrinter: printerInput.isPaperPrinter,
          printParams: this.getPrintParams(reportInput, this.existingValues)
        });
      }
      request = {
        'printReq': printReq,
        'jobIds': jobIds,
        'startTime': startTime
      };
    } else if (this.reportSource === 'ViewReport') {
      request = {
        moduleId: 'ViewReport',
        reportId: this.typeSelected,
        printerID: this.selectedPaperPrinter,
        noOfCopy: printerInput.noOfCopy,
        isPaperPrinter: printerInput.isPaperPrinter,
        printParams: this.getPrintParams(reportInput, this.existingValues),
        jobIds: jobIds,
        startTime: startTime
      };
    }
    this.reProcessPrintPreview(request);
  }

  public reProcessPrintPreview(request: any) {
    const jobsInProgress = []; // jobIds having status != 9
    this.printerSetupService.printPreview(this.reportSource, request).subscribe(resp => {
      if (resp.statusCode === 200 && resp.statusMessage === 'SUCCESS') {
        if (resp.previewResponses && resp.previewResponses.length > 0) {
          resp.previewResponses.forEach((report: any) => {
            if (report.status === '9') {
              this.completedJobIds.push(report.jobId);
              this.completedJobs.push({ 'jobId': report.jobId, 'reportUrl': report.reportURL });
            } else {
              jobsInProgress.push(report.jobId);
            }
          });
          if (jobsInProgress.length > 0) {
            request.jobIds = jobsInProgress.join('|');
            request.startTime = resp['startTime'];
            // should call the api again untill the job status became 9
            this.reProcessPrintPreview(request);
          } else {
            this.reportCounts = this.resourceService.get('lbl_preview_item_count').replace('%',
              this.completedJobs.length);
              /* [LFWM-3109] - adding loader for 3 seconds before showing the print preview to user,
               since SP is taking 3 seconds to load the data in pdf */
              this.loaderService.showLoader();
              setTimeout(() => {
                this.loaderService.hideLoader();
              }, 3000);
          }
        } else if (resp['errorMsg']) {
          this.alertService.clearAll().error(resp['errorMsg']);
        }
      } else {
        this.alertService.clearAll().error(this.resourceService
          .translateServerResponse(resp.statusMessage));
      }
    }, (err) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
    });
  }

  // [LFWM-2765] - to copy the single pdf link
  public copySingleLink(report: any) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = report.reportUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    if (selBox.value) {
      this.alertService.clearAll().success(this.resourceService.get('msg_succ_copy_link'));
    }
    document.body.removeChild(selBox);
  }

  // [LFWM-2765] - to download the single pdf
  public downloadSinglePdf(report: any) {
    const file_path = report.reportUrl;
    const a = document.createElement('a');
    a.href = file_path;
    a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // [LFWM-2765] - to preview the print pdf in new tab
  public toPreviewInNewTab(report: any) {
    this.printerSetupService.toPreviewInNewTab(report.jobId).subscribe((resp: any) => {
      const blobURL = URL.createObjectURL(resp);
      window.open(blobURL);
    }, (error) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }

  // [LFWM-2765] - to downlod all the padf as zip
  public downloadAllAsZipFile() {
    // LFWM-3191- adding tableId in the request
    let tableId: string = '';
    if (this.parentDataService && this.parentDataService.primarySearchParams) {
      tableId = this.parentDataService.primarySearchParams.tableId;
    } else if (this.tableSearchServiceForWaveControl) {
      tableId = this.tableSearchServiceForWaveControl.searchParams.tableId;
    }
    const request = { 
      'jobIds': this.completedJobIds.join('|'),
      'tableId' : tableId
    };
    this.printerSetupService.downloadAllAsZipFile(request).subscribe((resp: any) => {
      const blob = new Blob([this.s2ab(atob(resp.content))]);
      const file = new File([blob], resp.fileName,
        { type: 'text/csv' });
      this.fileUtilityService.saveFileLocally(file);
    }, (error) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }

  public s2ab(s: any) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      // tslint:disable-next-line:no-bitwise
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/print-lookup/print-lookup.component.ts